module.exports = __webpack_public_path__ + "line.gif";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/line.gif
// module id = 881
// module chunks = 11